import { render, staticRenderFns } from "./TournamentStats.vue?vue&type=template&id=4682211a&scoped=true&"
import script from "./TournamentStats.vue?vue&type=script&lang=js&"
export * from "./TournamentStats.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStats.vue?vue&type=style&index=0&id=4682211a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682211a",
  null
  
)

component.options.__file = "TournamentStats.vue"
export default component.exports